<template>
  <span aria-hidden="true"></span>
</template>

<script>
import { connect, disconnect } from '@/services/memberEntryHub.service';
import { resolveEntryHubBranchIds } from '@/utils/memberEntryHubBranches';

export default {
  name: 'MemberEntryHubBootstrap',
  computed: {
    token() {
      return this.$store.state.auth.userData
        ? this.$store.state.auth.userData.token
        : null;
    },
    // Read from the store on every change, never copied on mount: App.vue renders this layout
    // before the branch context has loaded, so a copy stayed empty and the popup never subscribed.
    branchIds() {
      return resolveEntryHubBranchIds(this.$store.state.auth, this.$store.getters.tenantBranches);
    },
    // Reconnect only when the set actually changes, not on every array identity.
    branchKey() {
      return this.branchIds.join(',');
    },
    // Same gates the Reception Desk sidebar item uses: tenant package + user action.
    hasReceptionAccess() {
      const tenantFeatures = this.$store.state.settings.tenantSetting
        && this.$store.state.settings.tenantSetting.tenantActiveFeatures;
      const userActions = this.$store.state.auth.userAuthActions;
      const tenantHas = Array.isArray(tenantFeatures)
        && tenantFeatures.indexOf('check-ins') !== -1;
      const userHas = Array.isArray(userActions)
        && userActions.some((a) => a && a.actionCode === 'reception-desk-enabled');
      return tenantHas && userHas;
    },
  },
  watch: {
    token: 'sync',
    branchKey: 'sync',
    hasReceptionAccess: 'sync',
  },
  mounted() {
    this.sync();
  },
  methods: {
    async sync() {
      if (!this.token || !this.hasReceptionAccess) {
        this.$store.commit('resetMemberEntryHubState');
        await disconnect();
        return;
      }
      await connect(this.branchIds);
    },
  },
};
</script>
